<template>
  <div>
    <div v-if="!detailBillStore.loading && !detailBillStore.error">
      <v-list>
        <v-list-item>
          <template #prepend>
            <v-icon>mdi-calendar</v-icon>
          </template>

            <v-list-item-subtitle>Datum</v-list-item-subtitle>
            <v-list-item-title>{{ detailBillStore.data?.RechnDatumFormatted }}</v-list-item-title>

        </v-list-item>
        <v-list-item v-if="detailBillStore.data?.Status == 2">
          <template #prepend>
            <v-icon>mdi-receipt-text</v-icon>
          </template>

            <v-list-item-subtitle>Storno zu Rechnung-Nr</v-list-item-subtitle>
            <v-list-item-title>{{ detailBillStore.data?.AlteRechnungNr }}</v-list-item-title>

        </v-list-item>
      </v-list>
      <div v-if="detailBillStore.data?.Dateien?.Values && detailBillStore.data.Dateien.Values.length >= 1" class="pb-3 px-3">
        <ApiDownload
          title="Rechnung herunterladen"
          :token="detailBillStore.data.Dateien.Values[0].DownloadToken"
          :fileName="detailBillStore.data.Dateien.Values[0].Dateiname"
        />
      </div>

      <hr />
      <v-table>
        <tbody>
          <tr v-for="position in detailBillStore.data?.AusgangsRechnungPositionen" :key="position.PosNr">
            <td class="py-2" valign="top" width="55" align="right">
              {{ position.Einheit.Menge }} <small>{{ position.Einheit.Einheit }}</small>
            </td>
            <td class="py-2">
              <strong>{{ position.Artikel.ArtikelBezeichnung1 }}</strong
              ><br />
              <div v-if="position.Artikel.ArtikelBezeichnung2">
                {{ position.Artikel.ArtikelBezeichnung2 }}<br />
              </div>
              <em>Art.-Nr.: {{ position.Artikel.ArtikelNr }}</em>
            </td>
            <td align="right">
              <strong>{{ position.Preise?.NettoBetrag.toLocaleString(undefined, { minimumFractionDigits: 2 }) }} €</strong>
            </td>
          </tr>
        </tbody>
      </v-table>

    </div>
    <template v-else-if="detailBillStore.error">
      <error :module="detailBillStore.$id" />
    </template>
  </div>
</template>
<script setup lang="ts">
import ErrorComp from '@/components/Error.vue';
import ApiDownload from '@/components/ApiDownload.vue';
import {useStorage} from '@/composables/storage';
import useDetailBillStore from '@/store/detailBill';

const detailBillStore = useDetailBillStore();
useStorage(detailBillStore,
    (data) => data?.RechnungNr ? `${data.Bezeichnung} ${data.RechnungNr}` : 'Rechnung',
    (route) => {
      return {
        KundenNr: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id),
        RechnungNr: parseInt(Array.isArray(route.params.bill_id) ? route.params.bill_id[0] : route.params.bill_id),
      };
    });

defineExpose({
  Error: ErrorComp,
  ApiDownload,
  detailBillStore,
});
</script>
